import withAPIAction from 'helpers/withAPIAction'
import {
  RewardListReq,
  CreateRewardReq,
  UpdateRewardReq,
  DeleteRewardReq,
  RewardDetailReq,
  RedeemRewardReq,
} from './types'
import {
  getRewardListAction,
  createRewardAction,
  updateRewardAction,
  deleteRewardAction,
  getRewardDetailAction,
  reedeemRewardAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const rewardListAPI = (data: RewardListReq, token: string) => {
  return withAPIAction<RewardListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.rewardList}?${getRequestString(data)}`,
    data,
    token,
  })(getRewardListAction)
}

export const createRewardAPI = (data: CreateRewardReq, token: string) => {
  return withAPIAction<CreateRewardReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createReward,
    data,
    token,
  })(createRewardAction)
}

export const updateRewardAPI = (data: UpdateRewardReq, token: string) => {
  const endPoint = APIPath.updateReward.replace(':id', data.id.toString())
  return withAPIAction<UpdateRewardReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(updateRewardAction)
}

export const deleteRewardAPI = (data: DeleteRewardReq, token: string) => {
  const endPoint = APIPath.deleteReward.replace(':id', data.id.toString())
  return withAPIAction<DeleteRewardReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(deleteRewardAction)
}

export const getRewardDetailAPI = (data: RewardDetailReq, token: string) => {
  const endPoint = APIPath.getRewardByID.replace(':id', data.id.toString())
  return withAPIAction<RewardDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(getRewardDetailAction)
}

export const redeemRewardAPI = (data: RedeemRewardReq, token: string) => {
  return withAPIAction<RedeemRewardReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.redeemReward,
    data,
    token,
  })(reedeemRewardAction)
}
